import { FontFamily } from 'src/models';
import { IS_ANDROID, IS_IOS } from '../helpers';
import { Zakeke } from './providerValue';
import { AppState } from './state';

export const createProviderValue = (state: AppState, dispatch: React.Dispatch<any>): Zakeke => {
	if (!state.environment) throw new Error('Invalid Zakeke environment.');

	return {
		userSettings: state.environment.userSettings,
		price: state.environment.price,
		isOutOfStock: state.environment.isOutOfStock,
		currency: state.environment.currency,
		culture: state.environment.culture,
		quantity: state.environment.quantity,
		quantityRule: state.environment.quantityRule,
		internalProduct: state.environment.internalProduct,
		internalScene: state.environment.internalScene,
		internalCurrentTemplate: state.environment.internalCurrentTemplate,

		draftCompositions: state.environment.themeCompositions,
		currentAttributesSelection: state.environment.currentAttributesSelection,
		isSceneLoading: state.isSceneLoading,
		isAddToCartLoading: state.isAddToCartLoading,
		isInfoPointContentVisible: state.environment.isInfoPointContentVisible,
		imagesMacroCategories: state.environment.imagesMacroCategories,
		fonts: state.environment.fonts,
		defaultFontID: state.environment.defaultFontID,
		disableTextColors: state.environment.disableTextColors,
		defaultColor: state.environment.defaultColor,
		textColors: state.environment.textColors,
		groups: state.environment.groups,
		templates: state.environment.templates,
		loadedComposition: state.environment.loadedComposition,
		currentTemplate: state.environment.currentTemplate,
		isViewerReady: state.environment.isViewerReady,
		items: state.environment.getDesignItemsInfo(),
		productName: state.environment.productName,
		productCode: state.environment.productCode,
		product: state.environment.product,
		cameras: state.environment.cameras,
		sellerSettings: state.environment.sellerSettings,
		eventMessages: state.environment.eventMessages,
		personalizedMessages: state.environment.personalizedMessages,
		visibleEventMessages: state.environment.visibleEventMessages,
		isAssetsLoading: state.environment.isAssetsLoading,
		isCompositionSaving: state.environment.isCompositionSaving,
		additionalCustomProperties: state.environment.additionalCustomProperties,
		currentCompositionInfo: state.environment.currentCompositionInfo,
		nftSettings: state.environment.nftSettings,
		isAIEnabled: state.environment.isAIEnabled,
		useLegacyScreenshot: state.environment.useLegacyScreenshot,
		uiConfig: state.environment.uiConfig,
		animationsConfig: state.environment.animationsConfig,
		backgroundColor: state.environment.backgroundColor || '#f2f2f2',
		removeBackground: state.environment.removeBackground,
		deepARsceneGLBUrl: state.environment.deepARsceneGLBUrl,
		shouldLoadDesign: state.environment.shouldLoadDesign,
		setMouseWheelZoomEnabled: state.environment.setMouseWheelZoomEnabled.bind(state.environment),
		setCameraPinchingZoom: state.environment.setCameraPinchingZoom.bind(state.environment),
		saveComposition: state.environment.saveComposition,
		loadComposition: state.environment.loadComposition,
		getPDF: state.environment.getPDF.bind(state.environment),
		fullyLoadFont: state.environment.fullyLoadFont.bind(state.environment),
		sanitizeString: state.environment.sanitizeString.bind(state.environment),
		getSanitationText: state.environment.getSanitationText.bind(state.environment),
		getOnlineScreenshot: state.environment.getOnlineScreenshot.bind(state.environment),
		reset: state.environment.reset.bind(state.environment),
		undo: state.environment.undo.bind(state.environment),
		redo: state.environment.redo.bind(state.environment),
		setCamera: state.environment.setCamera.bind(state.environment),
		setCameraByName: state.environment.setCameraByName.bind(state.environment),
		setCameraZoomEnabled: state.environment.setCameraZoomEnabled.bind(state.environment),
		resetCameraPivot: state.environment.resetCameraPivot.bind(state.environment),
		setCameraPivot: state.environment.setCameraPivot.bind(state.environment),
		setQuantity: state.environment.setQuantity.bind(state.environment),
		getImages: state.environment.getImages.bind(state.environment),
		openSecondScreen: state.environment.openSecondScreen.bind(state.environment),
		getMacroCategories: state.environment.getMacroCategories.bind(state.environment),
		createQuote: state.environment.createQuote,
		previewOnly__setItemImageFromBase64: async (guid: string, base64: string) => dispatch({ type: 'SET_ITEM_IMAGE_FROM_BASE64', guid, base64 }),
		setItemImageFromFile: state.environment.setItemImageFromFile.bind(state.environment),
		addItemImage: state.environment.addItemImage.bind(state.environment),
		createImage: state.environment.createImage.bind(state.environment),
		createImageFromUrl: state.environment.createImageFromUrl.bind(state.environment),
		setItemImage: state.environment.setItemImage.bind(state.environment),
		setItemFontFamily: state.environment.setItemFontFamily.bind(state.environment),
		setItemColor: state.environment.setItemColor.bind(state.environment),
		setItemBold: state.environment.setItemBold.bind(state.environment),
		setItemItalic: state.environment.setItemItalic.bind(state.environment),
		setItemTextOnPath: state.environment.setItemTextOnPath.bind(state.environment),
		setItemText: state.environment.setItemText.bind(state.environment),
		addItemText: state.environment.addItemText.bind(state.environment),
		removeItem: state.environment.removeItem.bind(state.environment),
		setItemConstraints: state.environment.setItemConstraints.bind(state.environment),
		setItemSize: state.environment.setItemSize.bind(state.environment),
		moveItemUp: state.environment.moveItemUp.bind(state.environment),
		moveItemDown: state.environment.moveItemDown.bind(state.environment),

		getPrintingMethods: state.environment.getPrintingMethods.bind(state.environment),
		setPrintingMethod: state.environment.setPrintingMethod.bind(state.environment),

		isFullscreenMode: state.environment.isFullscreenMode,
		switchFullscreen: () => dispatch({ type: 'SWITCH_FULLSCREEN' }),
		zoomIn: () => dispatch({ type: 'ZOOM_IN' }),
		zoomOut: () => dispatch({ type: 'ZOOM_OUT' }),
		stopAllAnimations: state.environment.stopAllAnimations.bind(state.environment),
		hasAnimations: state.environment.hasAnimations.bind(state.environment),
		playAnimations: state.environment.playAnimations.bind(state.environment),
		setHighlightSettings: (settings) => dispatch({ type: 'SET_HIGHLIGHT_SETTINGS', settings }),
		updateView: (adjustCamera) => dispatch({ type: 'UPDATE_VIEW', adjustCamera }),

		hasExplodedMode: state.environment.hasExplodedMode,
		isExplodedMode: state.environment.isExplodedMode,
		setExplodedMode: (exploded: boolean) => dispatch({ type: 'SET_EXPLODED_MODE', exploded }),

		internalAppendViewer: (container: HTMLElement) => dispatch({ type: 'APPEND_VIEWER', container }),

		getPrintingMethodsRestrictions: state.environment.getPrintingMethodsRestrictions.bind(state.environment),

		designUpdate: () => dispatch({ type: 'DESIGN_UPDATE' }),
		selectOption: (optionId: number) => dispatch({ type: 'SELECT_OPTION', optionId }),
		isAreaVisible: state.environment.isAreaVisible.bind(state.environment),
		setTemplate: async (templateId: number) => dispatch({ type: 'SET_TEMPLATE', templateId }),

		saveTemplate: state.environment.saveTemplate,

		addToCart: async (...params) => {
			dispatch({ type: 'IS_ADD_TO_CART_LOADING', isLoading: true });
			await state.environment.addToCart(...params);
		},

		// save compositions
		loadSavedComposition: state.environment.loadSavedComposition,
		saveDraftsComposition: state.environment.saveDraftsComposition,
		deleteSavedComposition: state.environment.deleteSavedComposition,

		// Scene manipulation
		getMeshIDbyName: state.environment.getMeshIDbyName.bind(state.environment),
		hideMeshAndSaveState: state.environment.hideMeshAndSaveState.bind(state.environment),
		restoreMeshVisibility: state.environment.restoreMeshVisibility.bind(state.environment),
		setMeshDesignVisibility: state.environment.setMeshDesignVisibility.bind(state.environment),
		exportSceneToGlb: state.environment.exportSceneToGlb,

		// Events
		clearListeners: state.environment.clearListeners,
		addFocusAttributesListener: state.environment.addFocusAttributesListener,
		focusAttribute: state.environment.focusAttribute,

		// Highlight
		highlightGroup: state.environment.hightlightGroup.bind(state.environment),
		highlightAttribute: state.environment.highlightAttribute.bind(state.environment),

		// AR
		getQrCodeArUrl: state.environment.getQrCodeArUrl,
		getMobileArUrl: state.environment.getMobileArUrl,
		openArMobile: state.environment.openArMobile,
		isSceneArEnabled: state.environment.isSceneArEnabled,
		isArDeviceCompliant: state.environment.isArDeviceCompliant,
		IS_ANDROID: IS_ANDROID,
		IS_IOS: IS_IOS,

		setBackgroundColor: state.environment.setBackgroundColor.bind(state.environment),

		// TRY ON
		getTryOnUrl: state.environment.getTryOnUrl.bind(state.environment),
		isSceneTryOnEnabled: state.environment.isSceneTryOnEnabled.bind(state.environment),
		isVisibleMeshShownForTryOn: state.environment.isVisibleMeshShownForTryOn,

		hasVTryOnEnabled: state.environment.hasVTryOnEnabled,
		canUseTryOn: state.environment.canUseTryOn,
		canUsePD: state.environment.canUsePD,
		isTryOnMeshVisible: state.environment.isTryOnMeshVisible,
		isMandatoryPD: state.environment.isMandatoryPD,
		getTryOnSettings: state.environment.getTryOnSettings.bind(state.environment),
		setPDDistance: state.environment.setPDDistance.bind(state.environment),
		pdDistance: state.environment.pdDistance,
		exportTryOnMeshToGlb: state.environment.exportTryOnMeshToGlb.bind(state.environment),

		setCameraLocked: state.environment.setCameraLocked.bind(state.environment),
		getTemplateUploadRestrictions: state.environment.getTemplateUploadRestrictions.bind(state.environment),
		getShareCompositionUrl: state.environment.getShareCompositionUrl.bind(state.environment),

		// copyright message
		getCopyrightMessageAccepted: state.environment.getCopyrightMessageAccepted.bind(state.environment),
		setCopyrightMessageAccepted: state.environment.setCopyrightMessageAccepted.bind(state.environment),

		// nft form
		validationNFTEmail: state.environment.validationNFTEmail.bind(state.environment),
		validationNFTWalletAddress: state.environment.validationNFTWalletAddress.bind(state.environment),

		configureByAI: state.environment.configureByAI.bind(state.environment),
		isAIStudioShoppingPreviewEnabled: state.environment.isAIStudioShoppingPreviewEnabled,
		isAIStudioEnabled: state.environment.isAIStudioEnabled,
		isAiEditorEnabled: state.environment.isAiEditorEnabled,
		isAiProductStagingEnabled: state.environment.isAiProductStagingEnabled,
		isAiVtoEnabled: state.environment.isAiVtoEnabled,
		startAIStudio: state.environment.startAIStudio.bind(state.environment),
		getAIPresetCategories: state.environment.getAIPresetCategories.bind(state.environment),
		getAIPresetPresets: state.environment.getAIPresetPresets.bind(state.environment),
		getApplicableAIStagingRules: state.environment.getApplicableAIStagingRules.bind(state.environment),
		getApplicableAIVirtualModelRules: state.environment.getApplicableAIVirtualModelRules.bind(state.environment),
		generateAIProductStaging: state.environment.generateAIProductStaging.bind(state.environment),
		generateAIVirtualTryon: state.environment.generateAIVirtualTryon.bind(state.environment),
		templateMacroCategories: state.environment.templateMacroCategories,
		applyTemplate: state.environment.applyTemplate.bind(state.environment),
		getDeepARDesktopIframeUrl: state.environment.getDeepARDesktopIframeUrl.bind(state.environment),

		// Font weight calculation methods
		getFontWeights: (font: FontFamily) => {
			const weights = state.environment.getFontWeights(font);
			return weights;
		},
		checkFontSupports: state.environment.checkFontSupports.bind(state.environment),

		T_static: state.environment.T_static.bind(state.environment),
		T_dynamic: state.environment.T_dynamic.bind(state.environment),
		areTranslationsLoaded: state.environment.areTranslationsLoaded,

		forceViewerResize: state.environment.forceViewerResize.bind(state.environment),
	};
};